import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const CHAPTERS = [
  {
    num: "01",
    testid: "manifesto-chapter-1",
    title: "Kenyan by registry, African by ambition.",
    body: "Hostech Solutions Limited is a Kenyan-registered technology company headquartered in Nairobi. We live where our clients operate — same time zone, same market realities, same drive to see East African hospitality run on world-class systems.",
  },
  {
    num: "02",
    testid: "manifesto-chapter-2",
    title: "The region's HTI Hospitality powerhouse.",
    body: "As the regional distributor for HTI Hospitality of South Africa, we bring the nebula suite — CRS, PMS and POS — plus Apex PMS and Plus Point POS to hotels, lodges and restaurant groups across the region, with local implementation, training and support.",
  },
  {
    num: "03",
    testid: "manifesto-chapter-3",
    title: "An in-house studio building its own flagships.",
    body: "Distribution taught us what the market truly needs. So we engineered it ourselves: HostPoint POS and HostPoint Retail — cloud-native, KRA eTIMS-ready, M-Pesa-integrated systems designed from the ground up for African hospitality and retail.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-20"
        >
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#263562]/60">
            The Manifesto
          </span>
          <h2 className="mt-4 font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl text-[#263562]">
            Three chapters. One hospitality{" "}
            <span className="text-[#3AB0E1]">operating system</span>.
          </h2>
        </motion.div>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.num}
              data-testid={c.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
              className="group grid md:grid-cols-[140px_1fr_1.2fr] gap-6 md:gap-12 items-start border-t border-[#263562]/10 py-14 hover:bg-[#263562]/[0.02] transition-colors duration-500"
            >
              <span className="font-display font-extrabold text-5xl md:text-6xl text-stroke-navy group-hover:text-[#263562] group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {c.num}
              </span>
              <h3 className="font-display font-bold tracking-tight text-xl sm:text-2xl leading-snug text-[#263562]">
                {c.title}
              </h3>
              <p className="text-base leading-relaxed text-[#5A6B85] font-light">
                {c.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
